import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { map } from 'rxjs';

export const unauthenticatedMatchGuard: CanMatchFn = () => {
    const authService: AuthService = inject(AuthService);

    return authService.checkAuthentication().pipe(map((authenticated) => !authenticated));
};
